import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  useScrollTrigger,
  Fab,
  Zoom,
  Avatar,
  Paper,
  Chip,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import {
  Church,
  Favorite,
  VolunteerActivism,
  Group,
  MenuBook,
  School,
  Business,
  Security,
  LocalHospital,
  EmojiPeople,
  KeyboardArrowUp,
  Phone,
  Email,
  WhatsApp,
  Facebook,
  Instagram,
  Twitter,
  ArrowForward,
  Star,
  History,
  Gavel,
  Public,
  Handshake,
  AccountBalance,
  TrendingUp,
  Groups,
  Info,
  Close,
  SportsBasketball,
  Agriculture,
  Park,
  Tour,
  Pets,
  MilitaryTech,
  ElderlyWoman,
  LockPerson
} from '@mui/icons-material';

// Importar el logo
import logo from '../assets/logo1.png';

// ImÃ¡genes para el carrusel
import carrusel1 from '../assets/carrusel1.jpg';
import carrusel2 from '../assets/carrusel2.jpg';
import carrusel3 from '../assets/carrusel3.jpg';

// Importar NavigationBar
import NavigationBarCapellanes from '../components/navigation/NavigationBarCapellanes';

// Importar traducciones
import { translations, defaultLanguage } from '../data/Translations';

// Paleta de colores
const colors = {
  gold: '#D4AF37',
  lightGold: '#F4E4BC',
  darkGold: '#B8960C',
  black: '#1A1A1A',
  darkGrey: '#2D2D2D',
  white: '#FFFFFF',
  offWhite: '#F8F6F0',
  cream: '#FDF8E8'
};

// BotÃ³n dorado personalizado
const GoldButton = ({ children, variant = 'contained', ...props }) => (
  <Button
    variant={variant}
    sx={{
      bgcolor: variant === 'contained' ? colors.gold : 'transparent',
      color: variant === 'contained' ? colors.black : colors.gold,
      border: variant === 'outlined' ? `2px solid ${colors.gold}` : 'none',
      px: 4,
      py: 1.5,
      fontSize: '1rem',
      fontWeight: 700,
      borderRadius: 2,
      textTransform: 'none',
      letterSpacing: '0.5px',
      boxShadow: variant === 'contained' ? '0 4px 20px rgba(212, 175, 55, 0.4)' : 'none',
      transition: 'all 0.3s ease',
      '&:hover': {
        bgcolor: variant === 'contained' ? colors.darkGold : 'rgba(212, 175, 55, 0.1)',
        transform: 'translateY(-2px)',
        boxShadow: variant === 'contained' ? '0 6px 24px rgba(212, 175, 55, 0.5)' : 'none'
      },
      ...props.sx
    }}
    {...props}
  >
    {children}
  </Button>
);

function ScrollTop(props) {
  const { children } = props;
  const trigger = useScrollTrigger({ disableHysteresis: true, threshold: 100 });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector('#back-to-top-anchor');
    if (anchor) {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <Zoom in={trigger}>
      <Box onClick={handleClick} role="presentation" sx={{ position: 'fixed', bottom: 16, right: 16, zIndex: 1000 }}>
        {children}
      </Box>
    </Zoom>
  );
}

// Mapeo de iconos para capellanÃ­as
const chaplaincyIconMap = {
  school: <School sx={{ fontSize: 45 }} />,
  sports: <SportsBasketball sx={{ fontSize: 45 }} />,
  business: <Business sx={{ fontSize: 45 }} />,
  gavel: <Gavel sx={{ fontSize: 45 }} />,
  agriculture: <Agriculture sx={{ fontSize: 45 }} />,
  eco: <Park sx={{ fontSize: 45 }} />,
  tour: <Tour sx={{ fontSize: 45 }} />,
  groups: <Groups sx={{ fontSize: 45 }} />,
  military: <MilitaryTech sx={{ fontSize: 45 }} />,
  pets: <Pets sx={{ fontSize: 45 }} />,
  prison: <LockPerson sx={{ fontSize: 45 }} />,
  hospital: <LocalHospital sx={{ fontSize: 45 }} />,
  elderly: <ElderlyWoman sx={{ fontSize: 45 }} />
};

function LandingPageCapellanes() {
  const navigate = useNavigate();
  const isAuthenticated = false;
  const user = null;
  
  // Estado para el idioma actual
  const [currentLang, setCurrentLang] = useState(() => {
    const savedLang = localStorage.getItem('preferredLanguage');
    if (savedLang && translations[savedLang]) return savedLang;
    const browserLang = navigator.language.split('-')[0];
    if (translations[browserLang]) return browserLang;
    return defaultLanguage;
  });
  
  // Estado para el modal de capellanÃ­as
  const [selectedChaplaincy, setSelectedChaplaincy] = useState(null);
  const [chaplaincyModalOpen, setChaplaincyModalOpen] = useState(false);
  
  const [hoveredCard, setHoveredCard] = useState(null);
  const [hoveredPrinciple, setHoveredPrinciple] = useState(null);
  const [hoveredChaplaincy, setHoveredChaplaincy] = useState(null);
  const [scrolled, setScrolled] = useState(false);

  // Estados para el logo arrastrable
  // const [logoPosition, setLogoPosition] = useState({ x: '45%', y: 70 });
  const [logoPosition, setLogoPosition] = useState({ x: '45%', y: 100 });
  const [logoScale, setLogoScale] = useState(1);
  const [isDragging, setIsDragging] = useState(false);
  const [isHoveringLogo, setIsHoveringLogo] = useState(false);
  const dragOffsetRef = useRef({ x: 0, y: 0 });

  const defaultLogoPosition = { x: '45%', y: 100 };
  const defaultLogoScale = 1;
  const ribbonOrigin = { x: '5%', y: '10%' };

  // Referencias para scroll - TODAS LAS SECCIONES
  const historiaRef = useRef(null);
  const aboutUsRef = useRef(null);
  const principiosRef = useRef(null);
  const valoresRef = useRef(null);
  const misionRef = useRef(null);
  const queEsChaplaincyRef = useRef(null);
  const chaplainciesRef = useRef(null);
  const funcionesRef = useRef(null);
  const testimoniosRef = useRef(null);
  const contactoRef = useRef(null);

  // Obtener traducciones actuales
  // Sincronizar idioma cuando el navbar lo cambia
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'preferredLanguage' && e.newValue && translations[e.newValue]) {
        setCurrentLang(e.newValue);
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const t = translations[currentLang] || translations[defaultLanguage];

  // Funciones para el modal de capellanÃ­as
  const handleOpenChaplaincyModal = (chaplaincy) => {
    setSelectedChaplaincy(chaplaincy);
    setChaplaincyModalOpen(true);
  };

  const handleCloseChaplaincyModal = () => {
    setChaplaincyModalOpen(false);
    setSelectedChaplaincy(null);
  };

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  };

  // Effect para manejar el scroll
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setScrolled(scrollY > 100);

      if (!isDragging) {
        const scrollProgress = Math.min(scrollY / 500, 1);
        const newX = 45 - (35 * scrollProgress);
        // const newY = 70 + (80 * scrollProgress);
        const newY = 100 + (80 * scrollProgress);
        setLogoPosition({ x: `${newX}%`, y: newY });
        // if (scrollY === 0) setLogoPosition(defaultLogoPosition);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDragging]);

  // Funciones para arrastrar el logo
  const handleDragStart = (e) => {
    e.preventDefault();
    const clientX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
    const clientY = e.type === 'touchstart' ? e.touches[0].clientY : e.clientY;
    setIsDragging(true);
    const currentX = typeof logoPosition.x === 'string' ? (window.innerWidth * parseFloat(logoPosition.x)) / 100 : logoPosition.x;
    dragOffsetRef.current = { x: clientX - currentX, y: clientY - logoPosition.y };
  };

  useEffect(() => {
    const handleDragMove = (e) => {
      if (!isDragging) return;
      const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
      const clientY = e.type === 'touchmove' ? e.touches[0].clientY : e.clientY;
      setLogoPosition({ x: `${((clientX - dragOffsetRef.current.x) / window.innerWidth) * 100}%`, y: clientY - dragOffsetRef.current.y });
    };
    const handleDragEnd = () => setIsDragging(false);

    if (isDragging) {
      window.addEventListener('mousemove', handleDragMove);
      window.addEventListener('mouseup', handleDragEnd);
      window.addEventListener('touchmove', handleDragMove, { passive: false });
      window.addEventListener('touchend', handleDragEnd);
    }
    return () => {
      window.removeEventListener('mousemove', handleDragMove);
      window.removeEventListener('mouseup', handleDragEnd);
      window.removeEventListener('touchmove', handleDragMove);
      window.removeEventListener('touchend', handleDragEnd);
    };
  }, [isDragging]);

  useEffect(() => {
    const handleWheel = (e) => {
      if (isHoveringLogo) {
        e.preventDefault();
        const delta = e.deltaY > 0 ? -0.1 : 0.1;
        setLogoScale(prev => Math.max(0.3, Math.min(5, prev + delta)));
      }
    };
    window.addEventListener('wheel', handleWheel, { passive: false });
    return () => window.removeEventListener('wheel', handleWheel);
  }, [isHoveringLogo, logoScale]);

  const handleLogoMouseEnter = () => setIsHoveringLogo(true);
  const handleLogoMouseLeave = () => setIsHoveringLogo(false);
  const resetLogo = () => { setLogoPosition(defaultLogoPosition); setLogoScale(defaultLogoScale); };
  const handleDoubleClick = (e) => { e.preventDefault(); resetLogo(); };

  // Iconos para valores y funciones
  const valueIcons = [<Church sx={{ fontSize: 50 }} />, <Handshake sx={{ fontSize: 50 }} />, <Favorite sx={{ fontSize: 50 }} />, <Gavel sx={{ fontSize: 50 }} />];
  const functionIcons = [<EmojiPeople sx={{ fontSize: 40 }} />, <MenuBook sx={{ fontSize: 40 }} />, <VolunteerActivism sx={{ fontSize: 40 }} />, <Group sx={{ fontSize: 40 }} />, <School sx={{ fontSize: 40 }} />, <Business sx={{ fontSize: 40 }} />, <Security sx={{ fontSize: 40 }} />, <LocalHospital sx={{ fontSize: 40 }} />];
  const areaIcons = [<LocalHospital />, <Security />, <Business />, <Public />];
  const timelineIcons = [<History sx={{ fontSize: 30, color: colors.gold }} />, <Security sx={{ fontSize: 30, color: colors.gold }} />, <VolunteerActivism sx={{ fontSize: 30, color: colors.gold }} />, <Church sx={{ fontSize: 30, color: colors.gold }} />];
  const principleIcons = [<Handshake sx={{ fontSize: 45 }} />, <AccountBalance sx={{ fontSize: 45 }} />, <TrendingUp sx={{ fontSize: 45 }} />, <Groups sx={{ fontSize: 45 }} />];

  const getInitials = (name) => name?.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2) || 'U';
  const stats = [{ number: '1,500+', label: t.stats.chaplains }, { number: '12', label: t.stats.countries }, { number: '50,000+', label: t.stats.lives }];

  return (
    <Box sx={{ bgcolor: colors.offWhite }}>
      {/* ═══════════════════════════════════════════════════════════════════════
          NAVIGATION BAR - Componente separado
      ═══════════════════════════════════════════════════════════════════════ */}
      <NavigationBarCapellanes 
        historiaRef={historiaRef}
        aboutUsRef={aboutUsRef}
        valoresRef={valoresRef}
        funcionesRef={funcionesRef}
        chaplainciesRef={chaplainciesRef}
        contactoRef={contactoRef}
      />

      <div id="back-to-top-anchor" />

      {/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
          HERO SECTION
      â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', position: 'relative', overflow: 'hidden', background: `linear-gradient(135deg, ${colors.black} 0%, ${colors.darkGrey} 50%, #3D3D3D 100%)`, pt: { xs: 12, md: 8 } }}>
        <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundImage: `radial-gradient(circle at 20% 80%, rgba(212, 175, 55, 0.15) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(212, 175, 55, 0.1) 0%, transparent 40%)`, pointerEvents: 'none' }} />
        <Box sx={{ position: 'absolute', top: '10%', left: '5%', width: '150px', height: '150px', border: `1px solid ${colors.gold}20`, borderRadius: '50%', animation: 'float 8s ease-in-out infinite' }} />

        {/* Cinta de la medalla */}
        {/* <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, pointerEvents: 'none', zIndex: 9998 }}>
          <svg width="100%" height="100%" style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none' }}>
            <path d={`M ${ribbonOrigin.x} ${ribbonOrigin.y} Q ${(parseFloat(logoPosition.x) > 50 ? (parseFloat(logoPosition.x) - 20) : (parseFloat(logoPosition.x) + 20))}% ${(logoPosition.y + 100) / 2} ${logoPosition.x} ${logoPosition.y}`} stroke={colors.gold} strokeWidth="3" fill="none" strokeDasharray="8,4" opacity="0.6" />
          </svg>
          <Box sx={{ position: 'absolute', left: ribbonOrigin.x, top: ribbonOrigin.y, width: '12px', height: '12px', borderRadius: '50%', bgcolor: colors.gold, transform: 'translate(-50%, -50%)', boxShadow: `0 0 15px ${colors.gold}`, animation: 'pulse 2s infinite' }} />
        </Box> */}

        {/* Logo flotante */}
        <Box sx={{ position: 'fixed', 
          top: typeof logoPosition.y === 'string' ? logoPosition.y : `${logoPosition.y}px`, 
          left: typeof logoPosition.x === 'string' ? logoPosition.x : `${logoPosition.x}px`, 
          // zIndex: 9999, 
          zIndex: 1100,
          cursor: isDragging ? 'grabbing' : 'grab', 
          userSelect: 'none', 
          touchAction: 'none', 
          transform: 'translate(-50%, 0)', 
          transition: isDragging ? 'none' : 'all 0.5s ease', 
          background: 'transparent' }} 
          onMouseDown={handleDragStart} onTouchStart={handleDragStart} onMouseEnter={handleLogoMouseEnter} onMouseLeave={handleLogoMouseLeave} onDoubleClick={handleDoubleClick}
        >
          <Box sx={{ position: 'relative', 
            // width: { xs: '120px', sm: '140px', md: '180px' }, 
            width: { xs: '80px', sm: '100px', md: '120px' },
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            transform: `scale(${logoScale})`, 
            transformOrigin: 'center center', 
            overflow: 'visible' }}>
            <Box component="img" src={logo} alt="Logo" sx={{ width: '100%', height: 'auto', objectFit: 'contain', filter: 'drop-shadow(0 0 20px rgba(212, 175, 55, 0.8))', pointerEvents: 'none', borderRadius: '40%', background: `radial-gradient(circle, ${colors.gold}10 0%, transparent 70%)` }} />
            <Box sx={{ position: 'absolute', top: '-20px', left: '-20px', right: '-20px', bottom: '-20px', border: `2px solid ${colors.gold}40`, borderRadius: '50%', animation: 'rotate 10s linear infinite', pointerEvents: 'none', zIndex: -1 }} />
          </Box>
        </Box>

        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'center', gap: { xs: 4, md: 6 } }}>
            <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 50%' }, maxWidth: { xs: '100%', md: '50%' }, width: { xs: '100%', md: '50%' } }}>
              <Chip label={t.hero.chip} sx={{ mb: 3, bgcolor: `${colors.gold}20`, color: colors.gold, fontWeight: 600, border: `1px solid ${colors.gold}40`, fontSize: '0.9rem', py: 2.5 }} />
              <Typography variant="h1" sx={{ color: 'white', fontWeight: 800, fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem', lg: '3.5rem' }, mb: 3, lineHeight: 1.2 }}>
                {t.hero.title}{' '}<Box component="span" sx={{ color: colors.gold }}>{t.hero.titleHighlight}</Box>
              </Typography>
              <Typography variant="h6" sx={{ color: 'rgba(255, 255, 255, 0.9)', mb: 4, fontSize: { xs: '1rem', md: '1.2rem' }, lineHeight: 1.6 }}>{t.hero.subtitle}</Typography>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <GoldButton startIcon={<Group />} endIcon={<ArrowForward />} onClick={() => navigate('/inscripcion')}>{t.hero.ctaJoin}</GoldButton>
                <GoldButton variant="outlined" startIcon={<History />} onClick={() => scrollToSection(historiaRef)}>{t.hero.ctaHistory}</GoldButton>
              </Box>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, mt: 4 }}>
                {stats.map((stat, index) => (
                  <Box key={index} sx={{ textAlign: 'center', minWidth: '80px' }}>
                    <Typography variant="h4" sx={{ color: colors.gold, fontWeight: 700 }}>{stat.number}</Typography>
                    <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>{stat.label}</Typography>
                  </Box>
                ))}
              </Box>
            </Box>

            {/* Carrusel */}
            <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 50%' }, maxWidth: { xs: '100%', md: '50%' }, width: { xs: '100%', md: '50%' }, display: { xs: 'none', md: 'block' } }}>
              <Box sx={{ position: 'relative', width: '100%', height: '500px' }}>
                <Box sx={{ width: '100%', height: '100%', borderRadius: 4, overflow: 'hidden', position: 'relative', boxShadow: `0 20px 60px rgba(0,0,0,0.4), 0 0 0 3px ${colors.gold}50`, background: `linear-gradient(135deg, ${colors.darkGrey} 0%, ${colors.black} 100%)` }}>
                  {[carrusel1, carrusel2, carrusel3].map((image, index) => (
                    <Box key={index} component="img" src={image} alt={`CapellanÃ­a ${index + 1}`} onError={(e) => { e.target.style.display = 'none'; }} sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top center', borderRadius: 4, animation: `carruselCadena 18s infinite`, animationDelay: `${index * 6}s`, zIndex: 1 }} />
                  ))}
                  <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', zIndex: 0 }}>
                    <Church sx={{ fontSize: 120, color: `${colors.gold}40`, mb: 2 }} />
                    <Typography sx={{ color: `${colors.gold}60`, fontSize: '1.2rem', fontWeight: 600 }}>{t.nav.brandName}</Typography>
                  </Box>
                  <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: `linear-gradient(180deg, transparent 50%, ${colors.black}90 100%)`, zIndex: 2, pointerEvents: 'none' }} />
                </Box>
                <Paper elevation={8} sx={{ position: 'absolute', top: 40, right: -20, p: 2, bgcolor: 'white', borderRadius: 2, animation: 'float 4s ease-in-out infinite', zIndex: 10, border: `2px solid ${colors.gold}` }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}><Church sx={{ color: colors.gold, fontSize: 32 }} /><Box><Typography variant="h6" sx={{ fontWeight: 700, color: colors.darkGrey }}>1,500+</Typography><Typography variant="caption" sx={{ color: 'text.secondary' }}>{t.floatingCards.chaplains}</Typography></Box></Box>
                </Paper>
                <Paper elevation={8} sx={{ position: 'absolute', bottom: 60, left: -20, p: 2, bgcolor: 'white', borderRadius: 2, animation: 'float 5s ease-in-out infinite', zIndex: 10, border: `2px solid ${colors.gold}` }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}><Public sx={{ color: colors.gold, fontSize: 32 }} /><Box><Typography variant="h6" sx={{ fontWeight: 700, color: colors.darkGrey }}>12 {t.floatingCards.countries}</Typography><Typography variant="caption" sx={{ color: 'text.secondary' }}>{t.floatingCards.countriesSubtitle}</Typography></Box></Box>
                </Paper>
                <Paper elevation={8} sx={{ position: 'absolute', top: '50%', right: -30, transform: 'translateY(-50%)', p: 2, bgcolor: colors.gold, borderRadius: 2, animation: 'float 6s ease-in-out infinite 1s', zIndex: 10 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}><Favorite sx={{ color: colors.black, fontSize: 28 }} /><Box><Typography variant="h6" sx={{ fontWeight: 700, color: colors.black }}>50K+</Typography><Typography variant="caption" sx={{ color: colors.darkGrey }}>{t.floatingCards.livesImpacted}</Typography></Box></Box>
                </Paper>
              </Box>
            </Box>

            <Box sx={{ display: { xs: 'flex', md: 'none' }, justifyContent: 'center', alignItems: 'center', py: 4, width: '100%' }}>
              <Box component="img" src={logo} alt="Logo" sx={{ width: '50%', maxWidth: 200, height: 'auto', filter: 'drop-shadow(0 0 30px rgba(212, 175, 55, 0.5))' }} />
            </Box>
          </Box>
        </Container>

        <Box sx={{ position: 'absolute', bottom: 30, left: '50%', transform: 'translateX(-50%)', animation: 'bounce 2s infinite', cursor: 'pointer' }} onClick={() => scrollToSection(historiaRef)}>
          <Typography sx={{ color: colors.gold, mb: 1, fontSize: '0.8rem' }}>{t.hero.scrollHint}</Typography>
          <KeyboardArrowUp sx={{ color: colors.gold, fontSize: 30, transform: 'rotate(180deg)' }} />
        </Box>
      </Box>

      {/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
          1. HISTORIA - ORÃGENES HISTÃ“RICOS
      â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <Box ref={historiaRef} sx={{ py: 12, background: `linear-gradient(180deg, ${colors.offWhite} 0%, ${colors.cream} 100%)`, position: 'relative', overflow: 'hidden' }}>
        <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, height: 4, background: `linear-gradient(90deg, transparent, ${colors.gold}, transparent)` }} />
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Chip label={t.history.chip} sx={{ mb: 2, bgcolor: colors.gold, color: colors.black, fontWeight: 700, fontSize: '0.9rem', py: 1 }} />
            <Typography variant="h2" sx={{ fontWeight: 700, color: colors.darkGrey, mb: 2, fontSize: { xs: '2rem', md: '2.5rem' } }}>{t.history.title}</Typography>
            <Typography variant="h6" sx={{ color: 'text.secondary', maxWidth: 700, mx: 'auto', fontSize: { xs: '1rem', md: '1.1rem' } }}>{t.history.subtitle}</Typography>
          </Box>

          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', lg: 'repeat(2, 1fr)' }, gap: 6, alignItems: 'center', mb: 6 }}>
            <Box sx={{ position: 'relative', borderRadius: 4, overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.3)', height: { xs: 300, md: 400 }, minHeight: 300 }}>
              <Box component="img" src={carrusel3} alt={t.history.saintName} onError={(e) => { e.target.style.display = 'none'; }} sx={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top center' }} />
              <Box sx={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '50%', background: `linear-gradient(transparent 0%, ${colors.black}90 100%)`, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', p: 3 }}>
                <Typography variant="h4" sx={{ color: colors.gold, fontWeight: 700, mb: 1, textShadow: '2px 2px 4px rgba(0,0,0,0.8)', fontSize: { xs: '1.5rem', md: '1.75rem' } }}>{t.history.saintName}</Typography>
                <Typography sx={{ color: colors.lightGold, fontSize: '1rem', mb: 2 }}>{t.history.saintDates}</Typography>
              </Box>
            </Box>
            <Box>
              <Typography sx={{ color: colors.darkGrey, lineHeight: 1.8, fontSize: '1.1rem', mb: 3 }} dangerouslySetInnerHTML={{ __html: t.history.paragraph1 }} />
              <Typography sx={{ color: colors.darkGrey, lineHeight: 1.8, fontSize: '1.1rem', mb: 3 }} dangerouslySetInnerHTML={{ __html: t.history.paragraph2 }} />
              <Typography sx={{ color: colors.darkGrey, lineHeight: 1.8, fontSize: '1.1rem' }} dangerouslySetInnerHTML={{ __html: t.history.paragraph3 }} />
            </Box>
          </Box>

          <Box sx={{ mb: 6 }}>
            <Typography variant="h5" sx={{ textAlign: 'center', color: colors.darkGrey, fontWeight: 600, mb: 4 }}>{t.history.timelineTitle}</Typography>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(4, 1fr)' }, gap: 3, position: 'relative' }}>
              <Box sx={{ position: 'absolute', top: '16%', left: '11%', right: '11%', height: 3, bgcolor: colors.gold, transform: 'translateY(-50%)', zIndex: 0, display: { xs: 'none', md: 'block' } }} />
              {t.history.timeline.map((item, index) => (
                <Paper key={index} sx={{ p: 3, textAlign: 'center', bgcolor: `${colors.gold}08`, border: `2px solid ${colors.gold}30`, borderRadius: 3, transition: 'all 0.3s ease', display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%', position: 'relative', zIndex: 1, '&:hover': { bgcolor: `${colors.gold}15`, transform: 'translateY(-5px)', boxShadow: '0 10px 30px rgba(212, 175, 55, 0.3)', borderColor: colors.gold } }}>
                  <Box sx={{ width: 20, height: 20, borderRadius: '50%', bgcolor: colors.gold, mb: 2, position: 'relative', zIndex: 2, boxShadow: `0 0 0 4px ${colors.offWhite}` }} />
                  <Typography variant="h5" sx={{ color: colors.gold, fontWeight: 700, fontSize: '1rem', mb: 1 }}>{item.year}</Typography>
                  <Typography variant="h6" sx={{ color: colors.darkGrey, fontWeight: 600, fontSize: '0.9rem', mb: 1 }}>{item.title}</Typography>
                  <Typography variant="body2" sx={{ color: colors.darkGrey, fontSize: '0.8rem', lineHeight: 1.4 }}>{item.description}</Typography>
                  <Box sx={{ mt: 2 }}>{timelineIcons[index]}</Box>
                </Paper>
              ))}
            </Box>
          </Box>

          <Paper sx={{ p: 4, bgcolor: `${colors.gold}10`, borderRadius: 3, border: `2px solid ${colors.gold}30`, position: 'relative', overflow: 'hidden', textAlign: 'center' }}>
            <Typography sx={{ fontStyle: 'italic', color: colors.darkGrey, fontSize: '1.2rem', lineHeight: 1.8, position: 'relative', zIndex: 1, mb: 3, maxWidth: 800, mx: 'auto' }} dangerouslySetInnerHTML={{ __html: t.history.etymologyQuote }} />
            <Box sx={{ position: 'relative', zIndex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
              <Divider sx={{ flex: 1, borderColor: colors.gold }} />
              <Typography sx={{ color: colors.gold, fontWeight: 600, fontSize: '1rem', minWidth: 'fit-content' }}>{t.history.etymologyLabel}</Typography>
              <Divider sx={{ flex: 1, borderColor: colors.gold }} />
            </Box>
          </Paper>
        </Container>
      </Box>

      {/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
          2. QUIÃ‰NES SOMOS
      â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <Box ref={aboutUsRef} sx={{ py: 12, background: `linear-gradient(135deg, ${colors.black} 0%, ${colors.darkGrey} 100%)`, position: 'relative' }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Chip label={t.aboutUs.chip} sx={{ mb: 2, bgcolor: colors.gold, color: colors.black, fontWeight: 700, fontSize: '0.9rem', py: 1 }} />
            <Typography variant="h2" sx={{ fontWeight: 700, color: colors.white, mb: 2, fontSize: { xs: '2rem', md: '2.5rem' } }}>
              {t.aboutUs.title}{' '}<Box component="span" sx={{ color: colors.gold }}>{t.aboutUs.titleHighlight}</Box>
            </Typography>
          </Box>

          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', lg: '1fr 1fr' }, gap: 6, mb: 8 }}>
            <Paper sx={{ p: 4, bgcolor: 'rgba(255,255,255,0.05)', border: `2px solid ${colors.gold}40`, borderRadius: 3, height: '100%' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                <Info sx={{ fontSize: 40, color: colors.gold }} />
                <Typography variant="h5" sx={{ color: colors.gold, fontWeight: 700 }}>{t.aboutUs.chip}</Typography>
              </Box>
              <Typography sx={{ color: colors.lightGold, lineHeight: 2, fontSize: '1.1rem', mb: 3 }}>{t.aboutUs.description}</Typography>
              <Typography sx={{ color: 'rgba(255,255,255,0.8)', lineHeight: 1.8, fontSize: '1rem' }} dangerouslySetInnerHTML={{ __html: t.aboutUs.visionInstitute }} />
            </Paper>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              <Paper sx={{ p: 4, bgcolor: `${colors.gold}10`, border: `2px solid ${colors.gold}`, borderRadius: 3 }}>
                <School sx={{ fontSize: 40, color: colors.gold, mb: 2 }} />
                <Typography sx={{ color: colors.white, lineHeight: 1.8, fontSize: '1rem' }} dangerouslySetInnerHTML={{ __html: t.aboutUs.educationFocus }} />
              </Paper>
              <Paper sx={{ p: 4, bgcolor: 'rgba(255,255,255,0.05)', border: `1px solid ${colors.gold}30`, borderRadius: 3 }}>
                <Public sx={{ fontSize: 40, color: colors.gold, mb: 2 }} />
                <Typography sx={{ color: 'rgba(255,255,255,0.9)', lineHeight: 1.8, fontSize: '1rem' }}>{t.aboutUs.modernVision}</Typography>
              </Paper>
              <Paper sx={{ p: 4, bgcolor: colors.gold, borderRadius: 3 }}>
                <Typography sx={{ color: colors.black, lineHeight: 1.8, fontSize: '1rem', fontWeight: 500 }}>{t.aboutUs.callToAction}</Typography>
              </Paper>
            </Box>
          </Box>
        </Container>
      </Box>

      {/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
          3. PRINCIPIOS - FUNDAMENTOS DE NUESTRA ORGANIZACIÃ“N
      â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <Box ref={principiosRef} sx={{ py: 12, background: `linear-gradient(180deg, ${colors.cream} 0%, ${colors.offWhite} 100%)` }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Chip label={t.principles.chip} sx={{ mb: 2, bgcolor: colors.gold, color: colors.black, fontWeight: 700, fontSize: '0.9rem', py: 1 }} />
            <Typography variant="h2" sx={{ fontWeight: 700, color: colors.darkGrey, mb: 2, fontSize: { xs: '2rem', md: '2.5rem' } }}>
              {t.principles.title}{' '}<Box component="span" sx={{ color: colors.gold }}>{t.principles.titleHighlight}</Box>
            </Typography>
            <Typography variant="h6" sx={{ color: 'text.secondary', maxWidth: 600, mx: 'auto' }}>{t.principles.subtitle}</Typography>
          </Box>

          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)' }, gap: 3 }}>
            {t.principles.items.map((principle, index) => (
              <Card key={index} elevation={hoveredPrinciple === index ? 16 : 4} onMouseEnter={() => setHoveredPrinciple(index)} onMouseLeave={() => setHoveredPrinciple(null)}
                sx={{ height: '100%', display: 'flex', flexDirection: 'column', borderRadius: 4, transition: 'all 0.4s ease', transform: hoveredPrinciple === index ? 'translateY(-12px)' : 'translateY(0)', border: hoveredPrinciple === index ? `2px solid ${colors.gold}` : '2px solid transparent', cursor: 'pointer', overflow: 'hidden', bgcolor: hoveredPrinciple === index ? colors.gold : colors.white }}>
                <CardContent sx={{ p: 4, textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', flexGrow: 1 }}>
                  <Box sx={{ width: 80, height: 80, borderRadius: '50%', bgcolor: hoveredPrinciple === index ? colors.black : `${colors.gold}20`, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3, color: colors.gold, transition: 'all 0.4s ease' }}>
                    {principleIcons[index]}
                  </Box>
                  <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: hoveredPrinciple === index ? colors.black : colors.darkGrey, lineHeight: 1.3 }}>{principle.title}</Typography>
                  <Typography variant="body2" sx={{ color: hoveredPrinciple === index ? colors.darkGrey : 'text.secondary', lineHeight: 1.6, flex: 1 }}>{principle.description}</Typography>
                </CardContent>
              </Card>
            ))}
          </Box>
        </Container>
      </Box>

      {/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
          4. VALORES - NUESTROS VALORES
      â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <Box ref={valoresRef} sx={{ py: 12, background: `linear-gradient(135deg, ${colors.darkGrey} 0%, ${colors.black} 100%)` }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Chip label={t.values.chip} sx={{ mb: 2, bgcolor: colors.gold, color: colors.black, fontWeight: 700 }} />
            <Typography variant="h2" sx={{ fontWeight: 700, color: colors.white, mb: 2 }}>{t.values.title}</Typography>
            <Typography variant="h6" sx={{ color: colors.lightGold, maxWidth: 600, mx: 'auto' }}>{t.values.subtitle}</Typography>
          </Box>

          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)' }, gap: 3 }}>
            {t.values.items.map((valor, index) => (
              <Card key={index} elevation={hoveredCard === index ? 16 : 4} onMouseEnter={() => setHoveredCard(index)} onMouseLeave={() => setHoveredCard(null)}
                sx={{ height: '100%', display: 'flex', flexDirection: 'column', borderRadius: 4, transition: 'all 0.4s ease', transform: hoveredCard === index ? 'translateY(-12px)' : 'translateY(0)', border: hoveredCard === index ? `2px solid ${colors.gold}` : '2px solid transparent', cursor: 'pointer', overflow: 'hidden', bgcolor: hoveredCard === index ? colors.gold : 'rgba(255,255,255,0.05)' }}>
                <CardContent sx={{ p: 4, textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', flexGrow: 1 }}>
                  <Box sx={{ width: 90, height: 90, borderRadius: '50%', bgcolor: hoveredCard === index ? colors.black : `${colors.gold}20`, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3, color: colors.gold, transition: 'all 0.4s ease', boxShadow: hoveredCard === index ? '0 8px 30px rgba(0, 0, 0, 0.4)' : 'none', flexShrink: 0 }}>
                    {valueIcons[index]}
                  </Box>
                  <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '100%' }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: hoveredCard === index ? colors.black : colors.white, lineHeight: 1.3, minHeight: '3.9em', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{valor.title}</Typography>
                    <Typography variant="body2" sx={{ color: hoveredCard === index ? colors.darkGrey : 'rgba(255,255,255,0.7)', lineHeight: 1.6, flex: 1 }}>{valor.description}</Typography>
                  </Box>
                </CardContent>
              </Card>
            ))}
          </Box>
        </Container>
      </Box>

      {/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
          5. MISIÃ“N Y VISIÃ“N
      â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <Box ref={misionRef} sx={{ py: 10, bgcolor: colors.cream }}>
        <Container maxWidth="lg">
          <Grid container spacing={6}>
            {[t.missionVision.mission, t.missionVision.vision].map((item, idx) => (
              <Grid item xs={12} md={6} key={idx}>
                <Paper elevation={6} sx={{ p: 5, height: '100%', borderRadius: 4, background: idx === 0 ? `linear-gradient(135deg, ${colors.black} 0%, ${colors.darkGrey} 100%)` : colors.white, border: `2px solid ${colors.gold}`, transition: 'transform 0.3s ease', '&:hover': { transform: 'scale(1.02)' } }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                    {idx === 0 ? <Favorite sx={{ fontSize: 50, color: colors.gold }} /> : <Church sx={{ fontSize: 50, color: colors.gold }} />}
                    <Typography variant="h4" sx={{ fontWeight: 700, color: idx === 0 ? colors.gold : colors.darkGrey }}>{item.title}</Typography>
                  </Box>
                  <Typography sx={{ color: idx === 0 ? colors.lightGold : colors.darkGrey, lineHeight: 2, fontSize: '1.1rem' }}>{item.text}</Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
          6. Â¿QUÃ‰ ES CAPELLANÃA?
      â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <Box ref={chaplainciesRef} sx={{ py: 10, background: `linear-gradient(135deg, ${colors.darkGrey} 0%, ${colors.black} 100%)`, position: 'relative' }}>
        <Container maxWidth="lg">
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', lg: 'repeat(2, 1fr)' }, gap: 6, alignItems: 'center' }}>
            <Box>
              <Typography variant="h3" sx={{ color: colors.white, fontWeight: 700, mb: 3 }}>
                {t.chaplaincy.title}{' '}<Box component="span" sx={{ color: colors.gold }}>{t.chaplaincy.titleHighlight}</Box>
              </Typography>
              <Typography sx={{ color: colors.lightGold, lineHeight: 2, fontSize: '1.1rem', mb: 3 }} dangerouslySetInnerHTML={{ __html: t.chaplaincy.paragraph1 }} />
              <Typography sx={{ color: 'rgba(255,255,255,0.8)', lineHeight: 2, fontSize: '1rem' }} dangerouslySetInnerHTML={{ __html: t.chaplaincy.paragraph2 }} />
            </Box>

            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' }, gap: 3 }}>
              {t.chaplaincy.areas.map((item, idx) => (
                <Paper key={idx} elevation={4} sx={{ p: 3, height: '100%', display: 'flex', alignItems: 'flex-start', gap: 3, bgcolor: 'rgba(255,255,255,0.05)', border: `1px solid ${colors.gold}30`, borderRadius: 2, transition: 'all 0.3s ease', minHeight: '140px', '&:hover': { transform: 'translateX(5px)', bgcolor: `${colors.gold}10`, borderColor: colors.gold } }}>
                  <Box sx={{ width: 50, height: 50, borderRadius: 2, bgcolor: `${colors.gold}20`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: colors.gold, flexShrink: 0 }}>
                    {React.cloneElement(areaIcons[idx], { sx: { fontSize: 25 } })}
                  </Box>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography sx={{ color: colors.white, fontWeight: 600, mb: 1, fontSize: '1rem' }}>{item.title}</Typography>
                    <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.85rem', lineHeight: 1.4 }}>{item.desc}</Typography>
                  </Box>
                </Paper>
              ))}
            </Box>
          </Box>
        </Container>
      </Box>

      {/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
          7. TIPOS DE CAPELLANÃAS
      â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <Box ref={queEsChaplaincyRef} sx={{ py: 12, background: `linear-gradient(180deg, ${colors.offWhite} 0%, ${colors.cream} 100%)` }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Chip label={t.chaplaincyTypes.chip} sx={{ mb: 2, bgcolor: colors.gold, color: colors.black, fontWeight: 700, fontSize: '0.9rem', py: 1 }} />
            <Typography variant="h2" sx={{ fontWeight: 700, color: colors.darkGrey, mb: 2, fontSize: { xs: '2rem', md: '2.5rem' } }}>
              {t.chaplaincyTypes.title}{' '}<Box component="span" sx={{ color: colors.gold }}>{t.chaplaincyTypes.titleHighlight}</Box>
            </Typography>
            <Typography variant="h6" sx={{ color: 'text.secondary', maxWidth: 700, mx: 'auto', mb: 2 }}>{t.chaplaincyTypes.subtitle}</Typography>
            <Typography variant="h5" sx={{ color: colors.gold, fontWeight: 700 }}>{t.chaplaincyTypes.cta}</Typography>
          </Box>

          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)', lg: 'repeat(4, 1fr)' }, gap: 3 }}>
            {t.chaplaincyTypes.items.map((chaplaincy, index) => (
              <Card
                key={chaplaincy.id}
                elevation={hoveredChaplaincy === index ? 16 : 4}
                onMouseEnter={() => setHoveredChaplaincy(index)}
                onMouseLeave={() => setHoveredChaplaincy(null)}
                onClick={() => handleOpenChaplaincyModal(chaplaincy)}
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  borderRadius: 3,
                  transition: 'all 0.4s ease',
                  transform: hoveredChaplaincy === index ? 'translateY(-12px) scale(1.02)' : 'translateY(0)',
                  border: hoveredChaplaincy === index ? `3px solid ${colors.gold}` : '2px solid transparent',
                  cursor: 'pointer',
                  overflow: 'hidden',
                  bgcolor: hoveredChaplaincy === index ? colors.black : colors.white,
                  '&:hover': { boxShadow: `0 20px 40px rgba(212, 175, 55, 0.3)` }
                }}
              >
                <CardContent sx={{ p: 3, textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', flexGrow: 1 }}>
                  <Box sx={{
                    width: 80, height: 80,
                    borderRadius: '50%',
                    bgcolor: hoveredChaplaincy === index ? colors.gold : `${colors.gold}15`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    mb: 2,
                    color: hoveredChaplaincy === index ? colors.black : colors.gold,
                    transition: 'all 0.4s ease',
                    boxShadow: hoveredChaplaincy === index ? '0 8px 30px rgba(212, 175, 55, 0.5)' : 'none'
                  }}>
                    {chaplaincyIconMap[chaplaincy.icon] || <Church sx={{ fontSize: 45 }} />}
                  </Box>
                  
                  <Typography variant="h6" sx={{ fontWeight: 700, mb: 1, color: hoveredChaplaincy === index ? colors.gold : colors.darkGrey, lineHeight: 1.2, fontSize: '1rem' }}>
                    {chaplaincy.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: hoveredChaplaincy === index ? colors.lightGold : 'text.secondary', lineHeight: 1.5, flex: 1, fontSize: '0.85rem' }}>
                    {chaplaincy.shortDesc}
                  </Typography>
                  
                  <Button
                    size="small"
                    sx={{
                      mt: 2,
                      color: hoveredChaplaincy === index ? colors.gold : colors.darkGold,
                      fontWeight: 600,
                      fontSize: '0.8rem',
                      '&:hover': { bgcolor: `${colors.gold}20` }
                    }}
                    endIcon={<ArrowForward sx={{ fontSize: 16 }} />}
                  >
                    {t.chaplaincyTypes.learnMore}
                  </Button>
                </CardContent>
              </Card>
            ))}
          </Box>
        </Container>
      </Box>

      {/* Modal de CapellanÃ­a */}
      <Dialog
        open={chaplaincyModalOpen}
        onClose={handleCloseChaplaincyModal}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 4,
            border: `3px solid ${colors.gold}`,
            bgcolor: colors.offWhite,
            overflow: 'hidden'
          }
        }}
      >
        {selectedChaplaincy && (
          <>
            <DialogTitle sx={{ 
              bgcolor: colors.black, 
              color: colors.gold, 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'space-between',
              py: 3,
              px: 4
            }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box sx={{ 
                  width: 60, height: 60, 
                  borderRadius: '50%', 
                  bgcolor: colors.gold, 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  color: colors.black
                }}>
                  {chaplaincyIconMap[selectedChaplaincy.icon] || <Church sx={{ fontSize: 35 }} />}
                </Box>
                <Typography variant="h5" sx={{ fontWeight: 700 }}>{selectedChaplaincy.title}</Typography>
              </Box>
              <IconButton onClick={handleCloseChaplaincyModal} sx={{ color: colors.gold, '&:hover': { bgcolor: `${colors.gold}20` } }}>
                <Close />
              </IconButton>
            </DialogTitle>
            
            <DialogContent sx={{ p: 4 }}>
              <Box sx={{ 
                p: 3, 
                bgcolor: `${colors.gold}10`, 
                borderRadius: 2, 
                border: `1px solid ${colors.gold}30`,
                mb: 3
              }}>
                <Typography sx={{ 
                  color: colors.darkGrey, 
                  fontWeight: 600, 
                  fontSize: '1.1rem',
                  fontStyle: 'italic'
                }}>
                  "{selectedChaplaincy.shortDesc}"
                </Typography>
              </Box>
              
              <Typography sx={{ 
                color: colors.darkGrey, 
                lineHeight: 2, 
                fontSize: '1.05rem',
                textAlign: 'justify'
              }}>
                {selectedChaplaincy.fullDescription}
              </Typography>
            </DialogContent>
            
            <DialogActions sx={{ p: 3, bgcolor: `${colors.gold}05`, borderTop: `1px solid ${colors.gold}30` }}>
              <Button onClick={handleCloseChaplaincyModal} sx={{ color: colors.darkGrey }}>
                {t.chaplaincyTypes.closeButton}
              </Button>
              <GoldButton onClick={() => { handleCloseChaplaincyModal(); navigate('/inscripcion'); }}>
                {t.nav.join}
              </GoldButton>
            </DialogActions>
          </>
        )}
      </Dialog>

      {/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
          8. FUNCIONES DEL CAPELLÃN
      â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <Box ref={funcionesRef} sx={{ py: 12, background: `linear-gradient(135deg, ${colors.darkGrey} 0%, ${colors.black} 100%)` }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Chip label={t.functions.chip} sx={{ mb: 2, bgcolor: colors.gold, color: colors.black, fontWeight: 700 }} />
            <Typography variant="h2" sx={{ fontWeight: 700, color: colors.white, mb: 2 }}>{t.functions.title}</Typography>
            <Typography variant="h6" sx={{ color: colors.lightGold, maxWidth: 600, mx: 'auto' }}>{t.functions.subtitle}</Typography>
          </Box>

          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)' }, gap: 3 }}>
            {t.functions.items.map((funcion, index) => (
              <Paper key={index} elevation={4} sx={{ p: 3, height: '100%', bgcolor: 'rgba(255,255,255,0.03)', border: `1px solid ${colors.gold}20`, borderRadius: 3, textAlign: 'center', transition: 'all 0.3s ease', display: 'flex', flexDirection: 'column', '&:hover': { bgcolor: 'rgba(212, 175, 55, 0.1)', borderColor: colors.gold, transform: 'translateY(-8px)' } }}>
                <Box sx={{ width: 70, height: 70, borderRadius: '50%', bgcolor: `${colors.gold}15`, display: 'flex', alignItems: 'center', justifyContent: 'center', mx: 'auto', mb: 2, color: colors.gold, flexShrink: 0 }}>{functionIcons[index]}</Box>
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                  <Typography variant="subtitle1" sx={{ color: colors.white, fontWeight: 600, mb: 1, flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{funcion.title}</Typography>
                  <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)', lineHeight: 1.6 }}>{funcion.desc}</Typography>
                </Box>
              </Paper>
            ))}
          </Box>
        </Container>
      </Box>

      {/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
          9. TESTIMONIOS - VOCES DE NUESTRA COMUNIDAD
      â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <Box ref={testimoniosRef} sx={{ py: 12, bgcolor: colors.offWhite }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Chip label={t.testimonials.chip} sx={{ mb: 2, bgcolor: colors.gold, color: colors.black, fontWeight: 700 }} />
            <Typography variant="h2" sx={{ fontWeight: 700, color: colors.darkGrey, mb: 2 }}>{t.testimonials.title}</Typography>
          </Box>

          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: 4 }}>
            {t.testimonials.items.map((testimonio, index) => (
              <Card key={index} elevation={4} sx={{ height: '100%', borderRadius: 3, borderTop: `4px solid ${colors.gold}`, display: 'flex', flexDirection: 'column' }}>
                <CardContent sx={{ p: 4, flex: 1, display: 'flex', flexDirection: 'column' }}>
                  <Box sx={{ display: 'flex', mb: 2 }}>{[...Array(5)].map((_, i) => (<Star key={i} sx={{ color: colors.gold, fontSize: 20 }} />))}</Box>
                  <Typography sx={{ mb: 3, fontStyle: 'italic', color: colors.darkGrey, lineHeight: 1.8, flex: 1 }}>"{testimonio.text}"</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 'auto' }}>
                    <Avatar sx={{ bgcolor: colors.gold, color: colors.black, width: 50, height: 50, fontWeight: 700 }}>{testimonio.avatar}</Avatar>
                    <Box><Typography variant="subtitle1" sx={{ fontWeight: 700 }}>{testimonio.name}</Typography><Typography variant="body2" sx={{ color: 'text.secondary' }}>{testimonio.role}</Typography></Box>
                  </Box>
                </CardContent>
              </Card>
            ))}
          </Box>
        </Container>
      </Box>

      {/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
          10. CTA - Â¿LISTO PARA SERVIR?
      â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <Box ref={contactoRef} sx={{ py: 12, background: `linear-gradient(135deg, ${colors.gold} 0%, ${colors.darkGold} 100%)`, position: 'relative', overflow: 'hidden' }}>
        <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundImage: `radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)`, pointerEvents: 'none' }} />
        <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1 }}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h2" sx={{ fontWeight: 800, color: colors.black, mb: 3 }}>{t.cta.title}</Typography>
            <Typography variant="h6" sx={{ color: colors.darkGrey, mb: 4, maxWidth: 600, mx: 'auto' }}>{t.cta.subtitle}</Typography>
            <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center', flexWrap: 'wrap' }}>
              <Button variant="contained" size="large" startIcon={<Group />} onClick={() => navigate('/inscripcion')} sx={{ bgcolor: colors.black, color: colors.gold, px: 5, py: 2, fontSize: '1.1rem', fontWeight: 700, borderRadius: 3, '&:hover': { bgcolor: colors.darkGrey, transform: 'scale(1.05)' } }}>{t.cta.buttonJoin}</Button>
              <Button variant="outlined" size="large" startIcon={<MenuBook />} onClick={() => navigate('/recursos')} sx={{ borderColor: colors.black, color: colors.black, borderWidth: 2, px: 5, py: 2, fontSize: '1.1rem', fontWeight: 700, borderRadius: 3, '&:hover': { borderWidth: 2, bgcolor: 'rgba(0,0,0,0.1)' } }}>{t.cta.buttonFormation}</Button>
            </Box>
          </Box>
        </Container>
      </Box>

      {/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
          FOOTER
      â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <Box sx={{ bgcolor: colors.black, color: colors.white, py: 8, borderTop: `2px solid ${colors.gold}` }}>
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            <Grid item xs={12} md={4}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                <Box component="img" src={logo} alt="Logo" sx={{ height: 60, width: 'auto' }} />
                <Typography variant="h6" sx={{ color: colors.gold, fontWeight: 700 }}>{t.nav.brandName}</Typography>
              </Box>
              <Typography sx={{ color: 'rgba(255,255,255,0.7)', lineHeight: 1.8 }}>{t.footer.description}</Typography>
            </Grid>

            <Grid item xs={12} md={4}>
              <Typography variant="h6" sx={{ color: colors.gold, fontWeight: 700, mb: 3 }}>{t.footer.contactTitle}</Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {[{ icon: <Phone />, text: '+57 1 234 5678' }, { icon: <Email />, text: 'info@alianzacapellanes.org' }, { icon: <WhatsApp />, text: '+57 300 123 4567' }].map((item, idx) => (
                  <Box key={idx} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}><Box sx={{ color: colors.gold }}>{item.icon}</Box><Typography sx={{ color: 'rgba(255,255,255,0.7)' }}>{item.text}</Typography></Box>
                ))}
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Typography variant="h6" sx={{ color: colors.gold, fontWeight: 700, mb: 3 }}>{t.footer.followTitle}</Typography>
              <Box sx={{ display: 'flex', gap: 2 }}>
                {[{ icon: <Facebook />, url: 'https://facebook.com' }, { icon: <Instagram />, url: 'https://instagram.com' }, { icon: <Twitter />, url: 'https://twitter.com' }, { icon: <WhatsApp />, url: 'https://whatsapp.com' }].map((social, idx) => (
                  <IconButton key={idx} onClick={() => window.open(social.url, '_blank')} sx={{ bgcolor: `${colors.gold}20`, color: colors.gold, '&:hover': { bgcolor: colors.gold, color: colors.black } }}>{social.icon}</IconButton>
                ))}
              </Box>
            </Grid>
          </Grid>

          <Divider sx={{ my: 4, borderColor: `${colors.gold}30` }} />
          <Typography sx={{ textAlign: 'center', color: 'rgba(255,255,255,0.5)' }}>{t.footer.copyright}</Typography>
        </Container>
      </Box>

      {/* Scroll to top */}
      <ScrollTop>
        <Fab size="medium" aria-label="scroll back to top" sx={{ bgcolor: colors.gold, color: colors.black, '&:hover': { bgcolor: colors.darkGold } }}><KeyboardArrowUp /></Fab>
      </ScrollTop>

      {/* CSS Animations */}
      <style>
        {`
          @keyframes float { 0%, 100% { transform: translateY(0px); } 50% { transform: translateY(-15px); } }
          @keyframes pulse { 0%, 100% { transform: scale(1); opacity: 0.5; } 50% { transform: scale(1.05); opacity: 0.8; } }
          @keyframes bounce { 0%, 20%, 50%, 80%, 100% { transform: translateX(-50%) translateY(0); } 40% { transform: translateX(-50%) translateY(-10px); } 60% { transform: translateX(-50%) translateY(-5px); } }
          @keyframes carruselCadena { 0% { transform: translateX(100%); z-index: 1; } 5% { transform: translateX(0%); z-index: 2; } 33.33% { transform: translateX(0%); z-index: 2; } 38.33% { transform: translateX(-100%); z-index: 1; } 100% { transform: translateX(-100%); z-index: 1; } }
          @keyframes rotate { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
        `}
      </style>
    </Box>
  );
}

export default LandingPageCapellanes;